import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "App/store";
import { logout } from "features/backstage/auth/authSlice";

export type PaginationResponse<T> = {
  totalCount: number;
  items: T[];
};

export const INITIAL_PAGINATION_RESPONSE: PaginationResponse<never> = {
  totalCount: 0,
  items: [],
};

export type Option = {
  label: string;
  value: string;
};

export type OptionEntity = {
  ids: string[];
  entities: {
    [id: string]: Option;
  };
};

export const INITIAL_ENTITY: OptionEntity = {
  ids: [],
  entities: {},
};

const BACKSTAGE_URL = "/functions";

export const getBackstageURL = (url: string) => BACKSTAGE_URL + url;

const baseQuery = fetchBaseQuery({
  baseUrl: "/api",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result?.meta?.response.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithAuth,
  endpoints: () => ({}),
  tagTypes: [
    "Approver",
    "Category",
    "Chart",
    "CityInfo",
    "CityInfoUpdateDate",
    "Function",
    "Log",
    "Role",
    "RoleFunction",
    "RoleUser",
    "User",
    "ViewsCount",
  ],
});

export default api;
